import { useMutation } from "@shared/lib/hooks";
import { IAdSegmentRequest } from "@shared/lib/types/drafting";
import { generateMediaAssetsKey } from "../../constants";
import { BriefService } from "../../services/brief.service";

export default function useAddAdSegment() {
  const {
    mutate: addAdSegment,
    isLoading: isAddAdSegmentLoading,
    error: addAdSegmentError,
    isSuccess: isAddAdSegmentSuccess,
    variables: addAdSegmentVariables,
  } = useMutation({
    mutationFn: (data: IAdSegmentRequest) => BriefService.addAdSegments(data),
    options: {
      skipInvalidation: true,
    },
    onSuccess: (c, _, variables) => {
      c.invalidateQueries({
        queryKey: [
          ...generateMediaAssetsKey({
            draftingId: variables.draftingId,
            draftingVersionId: variables.draftingVersionId,
            mediaAssetId: variables.mediaAssetId,
          }),
        ],
      });
    },
  });

  return {
    addAdSegment,
    isAddAdSegmentLoading,
    addAdSegmentError,
    isAddAdSegmentSuccess,
    addAdSegmentVariables,
  };
}
